import { directive as onClickaway } from "vue-clickaway";
import { mapActions, mapGetters, mapMutations } from "vuex";

import VideoProvider from "@/components/video-providers/index.vue";
import LessonSidebar from "../../../courses/components/lesson-sidebar/index.vue";
import Hypercomments from "@/components/features/comments/index.vue";
import { seo } from "@/mixins/seo";
import { throttle } from "lodash";

export default {
    name: "education-stream-detail",
    mixins: [seo],
    directives: {
        onClickaway: onClickaway,
    },
    data() {
        return {
            comments: "",
            activeClass: false,
        };
    },
    components: {
        VideoProvider,
        LessonSidebar,
        Hypercomments,
    },
    computed: {
        ...mapGetters({
            currentItem: "educationStreams/currentItem",
            isLoading: "educationStreams/isCurrentItemLoading",
            sortedSpeakers: "educationStreams/sortedSpeakers",
        }),
        getIdWidget() {
            if (!this.currentItem) return "";
            const t = this.currentItem.comments;
            const startIndex = t.indexOf("widget_id:");
            const endIndex = t.indexOf("});");
            const length = endIndex - startIndex;
            let result = t.substr(startIndex, length);
            return result.replace("widget_id:", "").replace(/"/g, "");
        },
    },
    watch: {
        currentItem() {
            if (this.currentItem && this.currentItem.hasOwnProperty("id")) {
                this.comments = this.currentItem.comments;
            }
            this.setPlaysinline();
        },
    },
    mounted() {
        if (this.currentItem) {
            if (this.currentItem && this.currentItem.hasOwnProperty("id")) {
                this.comments = this.currentItem.comments;
            }
            this.setPlaysinline();
        }

        this.$nextTick(() => {
            if (window.innerWidth < 600) {
                window.addEventListener("scroll", throttle(this.handleScroll, 15), true);
            }
        });
    },
    created() {
        this.fetchContent().then(() => {
            if (this.currentItem && this.currentItem.hasOwnProperty("id")) {
                Object.assign(this.seo, this.currentItem.seo.data);
                this.$emit("updateHead");
            }
        });
    },
    methods: {
        ...mapActions({
            fetchContent: "educationStreams/FETCH_STREAMS_ITEM",
        }),
        ...mapMutations({
            setCurrentItem: "educationStreams/STREAMS_SET_ITEM",
        }),
        handleScroll(e) {
            var el = document.getElementsByTagName("iframe")[0];
            this.activeClass = window.scrollY > el.offsetHeight - 200;
        },
        setPlaysinline() {
            this.$nextTick(() => {
                var el = document.getElementsByTagName("iframe")[0];
                el.setAttribute("playsinline", 1);
            });
        },
    },
    destroyed() {
        this.setCurrentItem(null);
    },
};
